const FILE_SIZE_STEPS = [
  { threshold: 1e9, suffix: ' GB' },
  { threshold: 1e6, suffix: ' MB' },
  { threshold: 1e3, suffix: ' KB' },
  { threshold: 0, suffix: ' B' },
];

// File size is formatted without digits and with SI-suffixes
export const fileSizeFormatter = (
  bytes: number,
  options?: Intl.NumberFormatOptions
) => {
  const formatterOptions = {
    useGrouping: true,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    ...options,
  };

  const sizeStep = FILE_SIZE_STEPS.find((step) => step.threshold <= bytes);

  if (sizeStep) {
    const fileSize = new Intl.NumberFormat([...navigator.languages], {
      ...formatterOptions,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(bytes / Math.max(1, sizeStep.threshold));

    return `${fileSize}${sizeStep.suffix}`;
  }

  return new Intl.NumberFormat(
    [...navigator.languages],
    formatterOptions
  ).format(bytes);
};
